import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { confirmationOfClassBeneficiariesDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const ConfirmationOfClassBeneficiariesFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={confirmationOfClassBeneficiariesDocumentTypesArray}
        placeholder="Select a confirmation of the class of beneficiaries document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default ConfirmationOfClassBeneficiariesFormValues;
